// hooks/useTypedTranslation.ts
import type { TOptions } from 'i18next'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { i18NextKeys } from '../generated/i18n.generated'

export const useTypedTranslation = () => {
  const { t: translate, ...rest } = useTranslation()

  // Ensure the translation key is treated as a string literal type
  const t = useMemo(
    () =>
      (key: i18NextKeys, options?: TOptions): string => {
        return translate(key, options)
      },
    [translate],
  )

  return {
    t,
    ...rest,
  } as const
}

// types/i18next.d.ts

declare module 'i18next' {
  interface CustomTypeOptions {
    defaultNS: 'translation'
    // `resources` is declared by i18n.generated.ts, which knows every namespace
    returnNull: false
    returnEmptyString: false
    // Ensure keys are treated as string literals
    key: i18NextKeys
  }
}
